import { render, staticRenderFns } from "./ProductSchemeReview.vue?vue&type=template&id=bd2e73e2&"
import script from "./ProductSchemeReview.vue?vue&type=script&lang=js&"
export * from "./ProductSchemeReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductSchemeReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductSchemeReview.vue"
export default component.exports